export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '__SIDE_BY_SIDE_IN_PROGRESS': 'Side-by-side in progress',
    '__END_SIDE_BY_SIDE': 'End side-by-side'
};
